function autoCheckFirstScreenPopup() {
	$('.singleCareer-btn button[data-popup]').on('click', function () {
		const containerPopulate = $('.redboxPopulateCptTitles').length
			? $('.redboxPopulateCptTitles')
			: $('.redboxPopulateCptTitlesEN');
		const $title = $('.singleCareer-title').text();
		const goodInput = containerPopulate.find(`input[value="${$title}"]`);

		goodInput.prop('checked', true);
		goodInput
			.parents('.gform_page')
			.find('.gform_next_button')
			.trigger('click');
	});
}

function autoCheckProjectPopup() {
	$('[data-tocheck]').on('click', function () {
		const $id = $(this).data('tocheck');

		$('.ginput_container')
			.find(`input[value="${$id}"]`)
			.prop('checked', true);
	});
}

function toAnchor() {
	$('.link-learn-more[href^="#"]').on('click', function (event) {
		event.preventDefault();

		const $id = $(this).attr('href');
		const top = Math.floor($($id).offset().top);
		const addWhichMedia = $(window).width() >= 1100 ? 0 : 70;
		const finalTop = top - addWhichMedia;

		$('html,body').animate(
			{
				scrollTop: finalTop,
			},
			500
		);
	});
}

export default {
	init() {
		autoCheckFirstScreenPopup();

		if ($('[data-tocheck]').length) {
			autoCheckProjectPopup();
		}

		if ($('.link-learn-more[href^="#"]').length) {
			toAnchor();
		}
	},
};
